import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Styles
import styles from './indicatorCard.scss';

const IndicatorCard = ({
  indicatorData,
}) => {
  const {
    shortTitle,
    slug,
    data: [
      {
        timeframe = '',
        formattedValue = 'n/a',
        _id = '',
      } = {},
    ] = [],
    parentData,
    dataView,
  } = indicatorData;
  return (
    <Link
      to={`/${dataView}/indicator/${slug}`}
      className={styles.indicatorCard}
    >
      <dl key={_id} className={styles.list}>
        <div className={styles.thisGeography}>
          <dt className={styles.title}>
            {shortTitle}
            <span className="screen-reader-text">
              of {shortTitle}
            </span>&nbsp;
            {'usdata' === dataView && timeframe.label &&
              <span aria-hidden className={styles.timeframeLabel}>
                {timeframe.label}
              </span>
            }
          </dt>
          <dd className={styles.value}>
            {formattedValue}
          </dd>
        </div>
        {parentData &&
          <div className={styles.parentGeography}>
            <dt className={styles.parentGeographyTitle}>
              <span className="screen-reader-text">
                {shortTitle} of
              </span>
              {parentData[0].geography.geography}
            </dt>
            <dd className={styles.parentGeographyValue}>
              {parentData[0].formattedValue}
            </dd>
          </div>
        }
      </dl>
      {'usdata' === dataView && (
        <div className={styles.viewAll} aria-hidden>
          View all states and counties
        </div>
      )}
      {'international' === dataView && (
        <div className={styles.viewAll} aria-hidden>
          View all countries and regions
        </div>
      )}
    </Link>
  );
};

IndicatorCard.propTypes = {
  indicatorData: PropTypes.object.isRequired,
};

export default IndicatorCard;



// WEBPACK FOOTER //
// ./app/components/indicatorCard/index.js